import { ChangeEvent, useState } from 'react'

import {
  setFieldset,
  setPriceRange,
} from '@/zustand/stores/price-range/usePriceRangeStore'

import setPriceParam from './setPriceParam'
import setRange from './setRange'

function useFieldsetState(range: number[], max: number) {
  const [validRange, setValidRange] = useState<number[]>()

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newRange = setRange(event, range, max)
    setValidRange(newRange)
  }

  const handleBlur = (event: ChangeEvent<HTMLInputElement>) => {
    if (validRange) {
      const { name } = event.target
      setFieldset(validRange)
      setPriceRange(validRange)

      if (name === 'price_from') return setPriceParam(name, validRange[0])

      setPriceParam(name, validRange[1])
    }
  }

  return { handleChange, handleBlur }
}

export default useFieldsetState
